'use client'

import { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'

export const useNavigationMobileShortcuts = () => {
  const { publish } = useEventBusContext()

  const handleMenuClick = useCallback(
    (level1: string) => {
      publish(EventType.MENU_CLICKED, {
        level1: level1 || undefined,
        level2: undefined,
        level3: undefined,
      })
    },
    [publish]
  )

  return { handleMenuClick }
}
